import React from 'react'
import { Grid, TextField, Typography, ToggleButtonGroup, ToggleButton, Box } from '@mui/material'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDButton from 'components/MDButton'
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined'

const segmentedStyle = {
  height: 44,
  borderRadius: 2,
  backgroundColor: "#f4f4f4",
  "& .MuiToggleButton-root": {
    textTransform: "none",
    fontWeight: 500,
    border: "none",
    borderRadius: 2,
    px: 2,
    "&.Mui-selected": {
      backgroundColor: "#49a3f1 !important",
      color: "#fff !important",
      transition: "all 0.2s ease",
    },
  },
}

function EntityStep({ entity, setEntity, dropdowns, errors, onOpenAiModal }) {
  const entityTypes = dropdowns.entityTypes || []
  const companies = dropdowns.companies || []
  const statusOptions = dropdowns.entityStatusOptions || []

  const handleChange = (field) => (event) => {
    const value = event.target.value
    setEntity((prev) => ({ ...prev, [field]: value }))
  }

  const currentEntityType = entityTypes.find(
    (t) => String(t.entity_type_id) === String(entity.entity_type_id),
  )
  const isIndividual =
    currentEntityType && typeof currentEntityType.type_name === 'string'
      ? currentEntityType.type_name.toLowerCase().includes('individual')
      : false

  return (
    <MDBox mt={2}>
      {/* AI Prefill button – shown only when handler provided */}
      {onOpenAiModal && (
        <Box display="flex" justifyContent="flex-end" mb={1}>
          <MDButton variant="gradient" color="info" onClick={onOpenAiModal} startIcon={<AutoAwesomeOutlinedIcon />}>AI Prefill</MDButton>
        </Box>
      )}
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <MDTypography variant="caption" fontWeight="bold" sx={{ mb: 1, display: "block" }}>
            Entity Type
          </MDTypography>

          <ToggleButtonGroup
            fullWidth
            exclusive
            value={entity.entity_type_id}
            onChange={(e, value) =>
              value && setEntity((prev) => ({ ...prev, entity_type_id: value }))
            }
            sx={segmentedStyle}
          >
            {entityTypes.map((type) => (
              <ToggleButton
                key={type.entity_type_id}
                value={type.entity_type_id}
                sx={{
                  textTransform: "none",
                  fontWeight: 500,
                }}
              >
                {type.type_name}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>

          {errors?.entity_type_id && (
            <Typography variant="caption" color="error">
              {errors.entity_type_id}
            </Typography>
          )}
        </Grid>

        <Grid item xs={12} md={4}>
          <MDTypography variant="caption" fontWeight="bold" sx={{ mb: 1, display: "block" }}>
            Status
          </MDTypography>

          <ToggleButtonGroup
            fullWidth
            exclusive
            value={entity.status_type_id}
            onChange={(e, value) =>
              value && setEntity((prev) => ({ ...prev, status_type_id: value }))
            }
            sx={segmentedStyle}
          >
            {statusOptions.map((s) => {
              const label = s.StatusType.status_name
              const isActive = label.toLowerCase().includes("active")

              return (
                <ToggleButton
                  key={s.status_option_id}
                  value={s.status_type_id}
                  sx={{
                    textTransform: "none",
                    fontWeight: 500,
                    color: isActive ? "success.main" : "text.secondary",
                  }}
                >
                  {label}
                </ToggleButton>
              )
            })}
          </ToggleButtonGroup>

          {errors?.status_type_id && (
            <Typography variant="caption" color="error">
              {errors.status_type_id}
            </Typography>
          )}
        </Grid>

        <Grid item xs={12} md={4}>
          <MDTypography variant="caption" fontWeight="bold" sx={{ mb: 1, display: "block" }}>
            Company
          </MDTypography>

          <ToggleButtonGroup
            fullWidth
            exclusive
            value={entity.company_id}
            onChange={(e, value) =>
              value && setEntity((prev) => ({ ...prev, company_id: value }))
            }
            sx={segmentedStyle}
          >
            {companies.map((s) => {
              const label = s.name

              return (
                <ToggleButton
                  key={s.company_id}
                  value={s.company_id}
                  sx={{
                    textTransform: "none",
                    fontWeight: 500,
                  }}
                >
                  {label}
                </ToggleButton>
              )
            })}
          </ToggleButtonGroup>

          {errors?.company_id && (
            <Typography variant="caption" color="error">
              {errors.company_id}
            </Typography>
          )}
        </Grid>

        {/* <Grid item xs={12} md={4}>
          <TextField
            select
            fullWidth
            label="Company"
            value={entity.company_id}
            onChange={handleChange('company_id')}
            error={Boolean(errors?.company_id)}
            helperText={errors?.company_id}
            size="small"
            InputProps={{
              sx: { height: 40, minHeight: 40 },
            }}
            SelectProps={{
              MenuProps: { PaperProps: { sx: { maxHeight: 300 } } }
            }}
            sx={{ '& .MuiSelect-select': { minHeight: 40, display: "flex", alignItems: "center" } }}
          >
            {companies.map((c) => (
              <MenuItem key={c.company_id} value={c.company_id}>
                {c.name}
              </MenuItem>
            ))}
          </TextField>
        </Grid> */}

        {isIndividual ? (
          <>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="First Name"
                value={entity.first_name}
                onChange={handleChange('first_name')}
                error={Boolean(errors?.first_name)}
                helperText={errors?.first_name}
                size="small"
                InputProps={{
                  sx: { height: 40, minHeight: 40 },
                }}
                sx={{ '& .MuiInputBase-input': { height: 40, boxSizing: 'border-box', padding: '16.5px 14px' } }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Last Name"
                value={entity.last_name}
                onChange={handleChange('last_name')}
                error={Boolean(errors?.last_name)}
                helperText={errors?.last_name}
                size="small"
                InputProps={{
                  sx: { height: 40, minHeight: 40 },
                }}
                sx={{ '& .MuiInputBase-input': { height: 40, boxSizing: 'border-box', padding: '16.5px 14px' } }}
              />
            </Grid>
          </>
        ) : (
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Company Name"
              value={entity.name}
              onChange={handleChange('name')}
              error={Boolean(errors?.name)}
              helperText={errors?.name}
              size="small"
              InputProps={{
                sx: { height: 40, minHeight: 40 },
              }}
              sx={{ '& .MuiInputBase-input': { height: 40, boxSizing: 'border-box', padding: '16.5px 14px' } }}
            />
          </Grid>
        )}
      </Grid>
    </MDBox>
  )
}

export default EntityStep

